<template>
    <div class="title-block">
        <div class="title-block__title">
            Добавить пользователя
        </div>
    </div>
    <form class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Введите имя пользователя</div>
            <input type="text" class="form-control" name="name" id="name">
        </div>
        <div class="mb-4">
            <div class="form-label">Введите электронную почту</div>
            <input type="email" class="form-control" name="email" id="email">
        </div>
        <div class="mb-4">
            <div class="form-label">Установите пароль</div>
            <input type="password" class="form-control" name="password" id="password">
        </div>
        <div class="mb-4">
            <div class="form-label">Повторите пароль</div>
            <input type="passwordConfirm" class="form-control" name="passwordConfirm" id="passwordConfirm">
        </div>
        <div class="mb-4">
            <div class="form-label">Выберите роль</div>
            <v-select
                v-model="role"
                :items="['Администратор', 'Программист', 'Менеджер DS', 'Менеджер клиента']"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>
        <div class="d-flex align-items-stretch py-3">
            <button type="button" class="btn btn-lg btn-primary flex-grow-1 me-3">
                Сохранить
            </button>
            <a href="/access-user-list" type="button" class="btn btn-lg btn-outline-dark flex-grow-1">
                Отменить
            </a>
        </div>
    </form>
</template>

<script>
export default {
    name: "AccessAddUser",
    data() {
        return {
            role: null
        }
    }
};
</script>
